<template>
  <div class="info">
    <form @submit.prevent="apply()">
      <div class="input-fields">
        <input
          @input="checkFields()"
          type="text"
          id="first_name"
          :placeholder="$t('authorization.name')"
          v-model="initModel.name"
          required
        />
        <label for="first_name">{{ $t("authorization.realName") }}</label>
        <small v-if="showError.nameLog">
          {{ $t("authorization.emptyArea") }}
        </small>
        <svg
          v-if="showError.nameLog"
          width="30"
          height="28"
          viewBox="0 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
            fill="#D34D4D"
          />
          <path
            d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
            fill="#D34D4D"
          />
          <path
            d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
            fill="#D34D4D"
          />
        </svg>
      </div>
      <div class="input-fields">
        <input
          @input="checkFields()"
          type="text"
          id="surname"
          :placeholder="$t('authorization.surname')"
          v-model="initModel.surname"
          required
        />
        <label for="surname">{{ $t("authorization.realsurname") }}</label>
        <small v-if="showError.surnameLog">
          {{ $t("authorization.emptyArea") }}
        </small>
        <svg
          v-if="showError.surnameLog"
          width="30"
          height="28"
          viewBox="0 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
            fill="#D34D4D"
          />
          <path
            d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
            fill="#D34D4D"
          />
          <path
            d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
            fill="#D34D4D"
          />
        </svg>
      </div>
      <div class="input-fields">
        <input
          @input="checkFields()"
          @focus="initModel.phone = initModel.phonevalue"
          type="phone"
          id="phone"
          maxlength="13"
          :placeholder="$t('authorization.phone')"
          v-model="initModel.phone"
          required
        />
        <label for="phone">{{ $t("authorization.enterPhone") }}</label>
        <small v-for="(item, index) in errormessage.phone" :key="index">
          {{ item }}
        </small>
        <svg
          v-if="showError.phoneLog"
          width="30"
          height="28"
          viewBox="0 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
            fill="#D34D4D"
          />
          <path
            d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
            fill="#D34D4D"
          />
          <path
            d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
            fill="#D34D4D"
          />
        </svg>
      </div>
      <div class="input-fields">
        <input
          @input="checkFields()"
          type="email"
          id="email"
          :placeholder="$t('authorization.email')"
          v-model="initModel.email"
          required
        />
        <label for="email">{{ $t("authorization.entermail") }}</label>
        <small
          for="email"
          v-for="(item, index) in errormessage.email"
          :key="index"
        >
          {{ item }}
        </small>
        <svg
          v-if="showError.emailLog"
          width="30"
          height="28"
          viewBox="0 0 30 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.7137 24.1033L16.829 1.78645C16.4473 1.12521 15.7635 0.730469 15 0.730469C14.2365 0.730469 13.5527 1.12521 13.171 1.78645L0.286348 24.1033C-0.0954492 24.7645 -0.0954492 25.5541 0.286348 26.2152C0.668086 26.8765 1.35182 27.2712 2.11535 27.2712H27.8846C28.6482 27.2712 29.3319 26.8765 29.7137 26.2152C30.0954 25.5541 30.0954 24.7645 29.7137 24.1033ZM28.1895 25.3353C28.1516 25.401 28.0614 25.5113 27.8847 25.5113H2.11535C1.93852 25.5113 1.8484 25.4011 1.81055 25.3353C1.77264 25.2696 1.72213 25.1364 1.81055 24.9833L14.6951 2.66641C14.7836 2.5133 14.9241 2.49039 14.9999 2.49039C15.0759 2.49039 15.2164 2.51324 15.3047 2.66641L28.1895 24.9833C28.2779 25.1364 28.2274 25.2696 28.1895 25.3353Z"
            fill="#D34D4D"
          />
          <path
            d="M15.8803 8.73242H14.1203V18.119H15.8803V8.73242Z"
            fill="#D34D4D"
          />
          <path
            d="M14.9993 22.2256C15.6473 22.2256 16.1726 21.7003 16.1726 21.0522C16.1726 20.4042 15.6473 19.8789 14.9993 19.8789C14.3513 19.8789 13.8259 20.4042 13.8259 21.0522C13.8259 21.7003 14.3513 22.2256 14.9993 22.2256Z"
            fill="#D34D4D"
          />
        </svg>
      </div>
      <div class="step-btn">
        <button id="submit_phone" class="recap"></button>
        <button
          id="submit_phone"
          type="submit"
          class="step"
          :disabled="
            !initModel.name ||
            !initModel.surname ||
            !initModel.phone ||
            !initModel.email
          "
        >
          {{ $t("authorization.continue") }}</button
        ><button class="mainPage">{{ $t("authorization.mainPage") }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import { useStore } from "vuex";
// import { useIMask } from "vue-imask";
import { useLanguage } from "@/utils/language";
import { unique } from "@/network/v1";

import {
  getAuth,
  signInWithPhoneNumber,
  RecaptchaVerifier,
} from "firebase/auth";

export default {
  /*  eslint-disable */
  setup(props, { emit }) {
    /* eslint-enable */
    let called = false;
    const store = useStore();

    const { i18n } = useLanguage();

    let initial = true;

    const initModel = reactive({
      name: "",
      surname: "",
      email: "",
      phone: "",
      phonevalue: "+998",
    });

    const errormessage = reactive({});

    let emailVerified = false;

    const showError = reactive({
      nameLog: false,
      surnameLog: false,
      emailLog: false,
      phoneLog: false,
      recaptchaLog: true,
    });

    const apply = async () => {
      Object.keys(errormessage).forEach((key) => {
        delete errormessage[key];
      });
      const formData = new FormData();

      formData.append("email", initModel.email);
      formData.append("phone", initModel.phone);

      await unique(
        () => {
          emailVerified = true;

          if (errormessage.phone || errormessage.email) {
            return;
          }
        },
        formData,
        async (res) => {
          const body = await res.json();
          for (const name in body) {
            errormessage[name] = body[name];
          }
          emailVerified = false;
        }
      );

      checkFields();

      if (!emailVerified) return;

      initial = false;

      if (
        showError.nameLog ||
        showError.surnameLog ||
        showError.emailLog ||
        showError.phoneLog ||
        called
      ) {
        return;
      }

      called = true;

      const appVerifier = window.recaptchaVerifier;

      // TODO DEBUG
      /* eslint-disable */
      // const test_number = "+16505553434";
      /* eslint-enable */

      // Send SMS
      // signInWithPhoneNumber(auth, test_number, appVerifier)
      console.log("WTF")
      signInWithPhoneNumber(auth, initModel.phone, appVerifier)
        .then((confirmationResult) => {
          // SMS sent. Prompt user to type the code from the message, then sign the
          // user in with confirmationResult.confirm(code).
          emit("submitForm");
          window.confirmationResult = confirmationResult;
        })
        .catch((error) => {
          console.log(error);
          // If e.g. too many request => ignore verification
          emit("submitForm", 2);
        });
    };
    const checkFields = async () => {
      store.commit("updateUserModel", initModel);
      if (initial) return;

      const userModel = store.getters.userModel;

      showError.nameLog = !userModel.name || !userModel.name.length === 0;
      showError.surnameLog =
        !userModel.surname || !userModel.surname.length === 0;
      showError.emailLog = !userModel.email || !userModel.email.length === 0;
      showError.phoneLog = !userModel.phone || !userModel.phone.length === 0;
    };

    const auth = getAuth();
    auth.languageCode = i18n.global.locale.value || i18n.global.locale;

    // DEBUG
    // auth.settings.appVerificationDisabledForTesting = true;

    onMounted(() => {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "submit_phone",
        {
          size: "invisible",
          callback: (response) => {
            // reCAPTCHA solved, allow signInWithPhoneNumber.
            console.log(response);
          },
        },
        auth
      );
    });

    return { initModel, showError, checkFields, initial, apply, errormessage };
  },
};
</script>

<style lang="scss" scoped>
.info {
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .input-fields {
      display: grid;
      grid-template-areas:
        "input svg"
        "warning warning"
        "realName realName";
      width: 24rem;
      input {
        grid-area: input;
        height: 3.4rem;
        font-size: 1.1em;
        line-height: 1.2em;
        font-weight: 400;
        outline: none;
        background: var(--input-bg);
        border: var(--input-border);
        padding: 0 1.2rem;
        ::placeholder {
          font-size: 1em;
          line-height: 1.2em;
          font-weight: 300;
        }
        &:focus {
          background: var(--input-focus-bg);
          border: 1px solid #cccccc;
        }
        &:focus ~ label {
          display: block;
        }
      }
      label {
        grid-area: realName;
        color: var(--explanation-color);
        font-size: 0.9em;
        line-height: 1.2em;
        font-weight: 300;
        margin-top: 0.2rem;
        display: none;
      }
      small {
        grid-area: warning;
        color: var(--warning-danger);
        font-size: 0.8em;
        line-height: 1.2em;
        margin-top: 0.2rem;
      }
      svg {
        grid-area: svg;
        margin-top: auto;
        margin-bottom: auto;
        margin-left: 1rem;
      }

      &:nth-child(1) {
        margin-top: 3.3rem;
      }
      &:nth-child(2) {
        margin-top: 2.8rem;
      }
      &:nth-child(3) {
        margin-top: 2.8rem;
      }
      &:nth-child(4) {
        margin-top: 2.8rem;
      }
    }
    .step-btn {
      display: flex;
      flex-direction: column;
      text-align: center;
      width: 100%;
      margin-left: 3rem;
      margin-top: 1.4rem;

      .recap {
        background-color: #fff;
        margin-bottom: 1rem;
      }

      .step {
        font-size: 1.5em;
        line-height: 0.8em;
        font-weight: 400;
        color: var(--explanation-color);
        border: 2px solid #6c8fba;
        background: transparent;
        outline: none;
        width: 17rem;
        height: 3.7rem;
        cursor: pointer;
        &:disabled {
          opacity: 0.5;
          pointer-events: none;
        }
      }
      .mainPage {
        font-size: 1.2em;
        line-height: 1.2em;
        background: transparent;
        color: var(--back-btn);
        border-bottom: 1px solid rgba(128, 128, 128, 1);
        margin-bottom: 3rem;
        margin-top: 1rem;
        width: max-content;
        margin-left: 2rem;
      }
    }
  }
}

@media screen and (max-width: 540px) {
  .info {
    form {
      .input-fields {
        width: 90%;
        input {
          width: 100%;
        }
      }
      .mainPage {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
